import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Icon } from '@iconify/react';
import PaginationWithSearch from '../../../components/PaginationWithSearch';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getFinDashDetails } from '../../../redux/features/financeSlice';
import { useLocation } from 'react-router-dom';
import GlobalSelectFieldWithoutFormikNew from '../../../components/mui/GlobalSelectFieldWithoutFormikNew';

const amountStatus = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Previous Month Pending' },
  { id: 2, name: 'Current Month Pending' },
  { id: 3, name: 'Total Collected' },
];
const FinanceView = () => {
  const [searchs, setSearch] = useState('');
  const { finDashDetails, loading } = useSelector((state) => state.finance);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const [amountSts, setAmountSts] = useState(queryParams.get('amountStatus') ?amountStatus.find((data)=>data.id==queryParams.get('amountStatus')):{});

  const data = {
    croId: queryParams.get('croId'),
    fromDate: queryParams.get('fromDate'),
    projectId: queryParams.get('projectId'),
    batchStatus: queryParams.get('batchStatus'),
    currency: queryParams.get('currency'),
    feeStatus:amountSts?.id
  };

  const handleNavigate = (row) => {
    const url = new URL(window.location.href);
    url.pathname = '/my-workspace/cart';

    if (row?.leadId) {
      url.searchParams.set('leadId', row.leadId);
    }

    window.open(url.toString(), '_blank');
  };
  return (
    <Box>
      <GlobalWrapper>
        {/* Search Field */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1,gap:1 }}>
          <Box>
            <GlobalSelectFieldWithoutFormikNew
              keys={{ itemId: 'id', itemValue: 'name' }}
              data={amountStatus}
              label={'Fee Filter'}
              // fullWidth={true}
              selectedDetails={amountSts}
              setChange={setAmountSts}
              sx={{ minWidth: '210px' }}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5 }}>
            <TextField size="small" label="Search" value={searchs} onChange={(e) => setSearch(e.target.value)} />
          </Box>
        </Box>

        {/* Table */}
        {loading ? (
          <Box
            sx={{
              height: 300,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box>
            <TableContainer component={Paper} sx={{ overflow: 'auto' }}>
              <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>admnNo</TableCell>
                    <TableCell>Student Name</TableCell>
                    <TableCell>Course Name</TableCell>
                    <TableCell>OGA Name</TableCell>
                    <TableCell>Course Enrolled Date</TableCell>
                    <TableCell>Expected Course Start Date</TableCell>
                    <TableCell>Expected Course End Date</TableCell>
                    <TableCell>Class Per Week</TableCell>
                    <TableCell>No Of Sessions</TableCell>
                    <TableCell>Forcast Type</TableCell>
                    <TableCell>Preferred Days</TableCell>
                    <TableCell>Subjects</TableCell>
                    <TableCell>Total Course Amt</TableCell>
                    <TableCell>Amount Paid</TableCell>
                    <TableCell>Amount Collected ByCro</TableCell>
                    <TableCell>Paid Percentage</TableCell>
                    <TableCell>To Collect</TableCell>
                    <TableCell>Week</TableCell>
                    <TableCell>Previous Month Pending Amount</TableCell>

                    <TableCell>Go to Cart</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {finDashDetails?.data?.map((row) => (
                    <TableRow
                      key={row.courseEnrollmentId}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                      }}
                    >
                      <TableCell>{row.admnNo}</TableCell>
                      <TableCell>{row.studentName}</TableCell>
                      <TableCell>{row.courseName}</TableCell>
                      <TableCell>{row.ogaName}</TableCell>
                      <TableCell>{row.courseEnrolledDate}</TableCell>
                      <TableCell>{row.courseStartDate}</TableCell>
                      <TableCell>{row.courseEndDate}</TableCell>
                      <TableCell>{row.classPerWeek}</TableCell>
                      <TableCell>{row.noOfSessions}</TableCell>
                      <TableCell>{row.forcastType}</TableCell>
                      <TableCell>{row.preferredDays}</TableCell>
                      <TableCell>{row.subjects}</TableCell>
                      <TableCell>{row.totalCourseAmt}</TableCell>
                      <TableCell>{row.amountPaid}</TableCell>
                      <TableCell>{row.amountCollectedByCro}</TableCell>
                      <TableCell>{row.paidPercentage}</TableCell>
                      <TableCell>{row.toCollect}</TableCell>
                      <TableCell>{row.predictedWeek}</TableCell>
                      <TableCell>{row.pendingAmount}</TableCell>

                      <TableCell>
                        <Box sx={{ width: 80 }}>
                          <Button
                            size="small"
                            onClick={() => handleNavigate(row)}
                            sx={{
                              color: 'white',
                              background: 'linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)',
                              borderRadius: 3,
                            }}
                          >
                            <Icon icon="mdi:cart-outline" height={22} width={22} />
                            Go to Cart
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {/* Loading Indicator */}

        {/* Pagination */}
        <PaginationWithSearch
          api={getFinDashDetails}
          meta={finDashDetails?.meta}
          loading={loading}
          search={searchs}
          otherProps={data}
        />
      </GlobalWrapper>
    </Box>
  );
};

export default FinanceView;
